import { render, staticRenderFns } from "./02-buffet.vue?vue&type=template&id=004bf0f6"
import script from "./02-buffet.vue?vue&type=script&lang=ts"
export * from "./02-buffet.vue?vue&type=script&lang=ts"
import style0 from "./02-buffet.vue?vue&type=style&index=0&id=004bf0f6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports